module.exports = __webpack_public_path__ + "static/flux-wireframe-2-95ee986d243ba28e7fc8e306801c533a.png";